function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0c6.63 0 12 5.37 12 12s-5.37 12-12 12S0 18.63 0 12 5.37 0 12 0zm0 1.2C6.04 1.2 1.2 6.04 1.2 12S6.04 22.8 12 22.8 22.8 17.96 22.8 12 17.96 1.2 12 1.2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.4 9.31C8.46 7.39 9.7 6 11.97 6c2.09 0 3.49 1.28 3.49 3.07 0 1.24-.58 2.11-1.62 2.76-1 .62-1.28 1.04-1.28 1.84v.46h-1.77l-.01-.55c-.07-1.22.37-1.94 1.43-2.6.95-.61 1.27-1.04 1.27-1.84 0-.84-.64-1.45-1.6-1.45-.98 0-1.62.63-1.68 1.62H8.4zM11.76 18c-.76 0-1.27-.51-1.27-1.29 0-.79.5-1.3 1.27-1.3.78 0 1.27.51 1.27 1.3-.01.78-.49 1.29-1.27 1.29z",
  fillRule: "evenodd",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.4 9.31C8.46 7.39 9.7 6 11.97 6c2.09 0 3.49 1.28 3.49 3.07 0 1.24-.58 2.11-1.62 2.76-1 .62-1.28 1.04-1.28 1.84v.46h-1.77l-.01-.55c-.07-1.22.37-1.94 1.43-2.6.95-.61 1.27-1.04 1.27-1.84 0-.84-.64-1.45-1.6-1.45-.98 0-1.62.63-1.68 1.62H8.4zM11.76 18c-.76 0-1.27-.51-1.27-1.29 0-.79.5-1.3 1.27-1.3.78 0 1.27.51 1.27 1.3-.01.78-.49 1.29-1.27 1.29z",
  fillRule: "evenodd",
  clipRule: "evenodd"
});

function SvgQuestionMarkRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "4d4d7317c5345f6df35b4895bb95e443.svg";
export { SvgQuestionMarkRound as ReactComponent };